import { FAQItem } from './TrustFAQ';

// TODO(i18n): estos contenidos están hardcodeados en español; migrar a claves i18n.

/**
 * FAQs de confianza para Path T (traspaso).
 */
export const TRANSFER_FAQ_ITEMS: FAQItem[] = [
	{
		question: '¿Cuánto me costará el traspaso?',
		answer: [
			'Nada. El traspaso de un plan de pensiones es **100% gratuito por ley**, vengas de la entidad que vengas.',
			'Funciona como la portabilidad de un número de móvil: tu entidad de origen está obligada a ejecutarlo, sin comisiones de salida ni penalizaciones. En Arca Digital tampoco te cobramos por recibirlo y gestionarlo.',
			'Además, **no tiene ningún impacto fiscal**: al ser un traspaso y no un rescate, no pagas impuestos a Hacienda por este movimiento.'
		]
	},
	{
		question: '¿Cuánto tiempo tarda?',
		answer: [
			'Depende del plan, pero tú ya no tienes que hacer nada, nosotros nos encargamos:',
			{
				items: [
					'**Individuales:** de 2 a 4 semanas.',
					'**De empleo:** de 6 a 8 semanas (por trámites legales extra).'
				]
			},
			'**¿Por qué tarda?** Tu entidad actual necesita unos plazos legales para liberar y enviar tu dinero de forma segura.',
			'Desde tu cuenta podrás seguir el traspaso paso a paso, como si fuera un pedido online. Te avisaremos en cuanto el dinero llegue a Arca Digital.'
		]
	},
	{
		question: '¿Dónde está mi dinero y quién tiene acceso a él?',
		answer: [
			'Durante el traspaso, **tu dinero sigue en tu plan actual**. Nunca se queda "en el aire", sino que pasa directamente a Caser Pensiones (Grupo Helvetia), la nueva entidad depositaria.',
			'**Solo tú tienes acceso.** Ni Arca Digital ni la gestora podemos tocarlo. Tu patrimonio está separado: incluso si Arca Digital cerrara mañana, tus ahorros seguirían 100% seguros e intactos bajo la custodia de Caser.'
		]
	},
	{
		question: '¿Qué gana Arca Digital con esto?',
		answer: [
			'Cobramos una comisión que negociamos directamente con la gestora del plan. Esta comisión ya viene incluida de base en el coste total del producto, por lo que **no supone ningún gasto extra de tu bolsillo**.',
			'En Arca Digital queremos ser transparentes: **pagarás exactamente lo mismo** que si contrataras el plan por tu cuenta. Nunca te pasaremos un recibo, ni te cobraremos directamente, ni verás ningún cargo adicional por usar nuestro servicio.'
		]
	},
	{
		question: '¿Cómo funciona la gestión de mis planes de pensiones?',
		answer: [
			'Desde tu cuenta en Arca Digital puedes consultar tu plan en cualquier momento.',
			'Si decides cambiar de producto o necesitas realizar un trámite, **nosotros nos encargamos de todo**. Te ahorras llamar al banco y lidiar con el tedioso papeleo.',
			'Aunque la gestora del plan es quien ejecuta finalmente los cambios, desde nuestra plataforma centralizamos tus gestiones para hacértelo todo mucho más fácil, rápido y sin ningún dolor de cabeza para ti.'
		]
	},
	{
		question: '¿Por qué fiarme de Arca Digital y no de mi banco?',
		answer: [
			'Tu banco solo te ofrece sus propios planes y tiene incentivos para venderte los que le dejan mayor margen.',
			'Arca Digital es un **corredor de seguros totalmente independiente** (registro DGSFP J4556) y no tiene planes propios que colocarte. Elegimos nuestro catálogo basándonos en la rentabilidad, no en el margen.',
			'Somos **100% transparentes**: siempre podrás comparar las comisiones y la rentabilidad real de cualquier producto, incluido el tuyo actual.'
		]
	}
];

/**
 * FAQs para Path N (nuevo plan): objeciones sobre la naturaleza del producto
 * (iliquidez, fiscalidad, tipo de gestión), no sobre el traspaso.
 */
export const NEW_PLAN_FAQ_ITEMS: FAQItem[] = [
	{
		question: '¿Cuándo puedo recuperar mi dinero?',
		answer:
			'Los planes de pensiones son ilíquidos: en general no puedes rescatarlos antes de la jubilación, salvo en supuestos excepcionales (desempleo de larga duración, enfermedad grave, dependencia, o a partir de 2025 para aportaciones con más de 10 años de antigüedad). El beneficio fiscal que recibes cada año es la compensación por esa iliquidez.'
	},
	{
		question: '¿Puedo dejar de aportar o cambiar la cantidad?',
		answer:
			'Sí, en cualquier momento y sin coste ni penalización. Puedes pausar, reducir, aumentar o dejar la aportación a cero. El plan sigue activo y el dinero ya acumulado sigue invertido.'
	},
	{
		question: '¿Puedo cambiar de plan después?',
		answer:
			'Sí. Traspasar entre planes de pensiones es gratuito, no tributa y no tiene plazo mínimo de permanencia. Si en el futuro prefieres otra filosofía de inversión, lo gestionamos nosotros.'
	},
	{
		question: '¿Qué ventaja fiscal tengo exactamente?',
		answer:
			'Cada euro que aportas reduce tu base imponible en el IRPF ese año. Con 1.500 € al año y un tipo marginal del 30%, el ahorro es de 450 € anuales. Cuando rescates el plan, tributarás por ello como rendimiento del trabajo, pero en ese momento tu base imponible suele ser menor.'
	},
	{
		question: '¿Qué diferencia hay entre un plan indexado y uno de gestión activa?',
		answer:
			'Un plan indexado (como Indexa) replica automáticamente el mercado con comisiones muy bajas. Uno de gestión activa (como Horos o Magallanes) tiene un equipo que selecciona qué empresas comprar. La diferencia de comisión puede llegar a 1 punto porcentual anual — que en 20 años equivale a decenas de miles de euros en cualquier dirección.'
	},
	{
		question: '¿Por qué abrir el plan con Arca Digital y no directamente con la gestora?',
		answer:
			'Puedes contratar algunos de estos planes directamente con la gestora. La diferencia es que en Arca Digital tienes todas las opciones en un sitio, podemos ayudarte a comparar, y si en el futuro quieres cambiar de plan lo gestionamos nosotros. El coste del plan es el mismo.'
	},
	{
		question: '¿Qué pasa con mi plan si dejo de trabajar o me quedo sin ingresos?',
		answer:
			'El plan sigue activo con el dinero acumulado, invertido según la filosofía que elegiste. No pasa nada. Puedes pausar las aportaciones sin coste. Si cumples los requisitos de rescate anticipado por desempleo de larga duración, podrás acceder al dinero en ese momento.'
	}
];
